"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateActor = exports.userIsLoggedIn = exports.getActor = exports.getUserId = exports.WARN_CIS_SYNC_LOGIN_UNDEFINED = void 0;
var actor_1 = require("../builders/actor");
var utils_1 = require("../builders/utils");
var warnOnce_1 = __importDefault(require("../warnOnce"));
/**
 * @internal exported for testing
 */
exports.WARN_CIS_SYNC_LOGIN_UNDEFINED = 'Cis sync initiated with no actor builder and no event available. If you do not use a login system, please indicate' +
    ' this using tracker.update({ actor: undefined }), otherwise do tracker.update({ actor: somePromise }) with a' +
    ' promise that resolves to the login state.';
/**
 * Get the actor id (userId) from the current browser. A promise is returned
 * because a call may be made to complete the login process.
 *
 * *Note*: This method will return a Promise that is always rejected on node
 environments.
 @category Identifiers
 */
var getUserId = function (builders) { return __awaiter(void 0, void 0, void 0, function () {
    var id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getActor(builders)];
            case 1:
                id = (_a.sent()).id;
                return [2 /*return*/, id];
        }
    });
}); };
exports.getUserId = getUserId;
/**
 * @category Identifiers
 */
var getActor = function (builders) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, evaluateActor(builders)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getActor = getActor;
var userIsLoggedIn = function (builders) { return __awaiter(void 0, void 0, void 0, function () {
    var actor;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getActor(builders)];
            case 1:
                actor = _a.sent();
                return [2 /*return*/, !!(actor === null || actor === void 0 ? void 0 : actor.id)];
        }
    });
}); };
exports.userIsLoggedIn = userIsLoggedIn;
/**
 * Evaluate actor input given to the sdk/this method and pass it through the
 * Actor event formatter.
 * @category Tracker
 * @private
 */
var evaluateActor = function (eventInput, builders) {
    if (eventInput === void 0) { eventInput = {}; }
    if (builders === void 0) { builders = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((0, actor_1.isActorInput)(eventInput) || (0, actor_1.isActorInput)(builders))) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, utils_1.evaluateAndFlatten)(eventInput.actor || builders.actor || {})];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    // We allow an empty actor object, because it is a sign that the application is not setting nor updating Actor correctly.
                    // Inferring "id: undefined" as a fallback would mask that bug.
                    // Hence, the warning below.
                    (0, warnOnce_1.default)("no-actor-builder-and-no-event-present", exports.WARN_CIS_SYNC_LOGIN_UNDEFINED);
                    return [2 /*return*/, {}];
            }
        });
    });
};
exports.evaluateActor = evaluateActor;
